import Vue from 'vue'

import { createPinia, PiniaVuePlugin } from 'pinia';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// 创建 Pinia 实例
const pinia = createPinia();
// 使用持久化插件
pinia.use(piniaPluginPersistedstate);

// 将 Pinia 挂载到 Vue 2
Vue.use(PiniaVuePlugin);

export default pinia;

export * from './systemStore.js'